import store from "../redux/store";
import { Callback, signOut, addSignOutCallback } from "../redux/authentication/actions";

const getTimeoutMs = () => store.getState().configuration.maximumIdleTimeoutForLockoutInSeconds * 1000;
let inactivityTimeoutHandle: number | null;

const clearInactivityTimer: Callback = () => {
    if (inactivityTimeoutHandle) {
        clearTimeout(inactivityTimeoutHandle);
        inactivityTimeoutHandle = null;
    }
};

addSignOutCallback(clearInactivityTimer);

export const resetInactivityTimer = (bForce = false) => {
    if (inactivityTimeoutHandle || bForce) {
        clearInactivityTimer();
        inactivityTimeoutHandle = window.setTimeout(() => {
            store.dispatch(signOut());
            inactivityTimeoutHandle = null;
        }, getTimeoutMs());
    }
};
